const ods = {
   title: "UX/UI Research & Development",
   organization: "OneDataShare",
   web: "https://www.onedatashare.org/",
   location: "Buffalo, New York",
   date: "January 2020 - May 2020",
   details: [
      "Conducted research to determine appropriate updates to the UX/UI.",
      "Updated legacy components to be more user friendly.",
      "Broke down and simplifying components to make them more modular and easier to reuse.",
   ],
   skills: "UX/UI Design, React, JavaScript",
};

const sahead = {
   title: "Head Graphic Artist",
   organization: "Undergraduate Student Association",
   location: "Buffalo, New York",
   web: "https://sa.buffalo.edu/",
   date: "September 2019 - May 2020",
   details: [
      "Continuing my responsibilities as a Graphic Artist",
      "Coordinating with senior leadership to create an more established brand on social media",
      "Leading a team of 3 Graphic Artists to utilize our strongest design styles to establish a higher level of consistency with our growing image.",
   ],
   skills: "Graphic Design, Adobe Creative Cloud",
};

const cnbc = {
   title: "Digital Product Intern",
   organization: "CNBC",
   web: "https://www.cnbc.com/",
   location: "Englewood Cliffs, New Jersey",
   date: "June 2019 - August 2019",
   details: [
      "Completed research on how to target a new demographic audience.",
      "Completed research on a new revenue stream.",
      "Proposed a new digital product to expand the current revenue model and target demographic.",
   ],
   skills: "Product Design, Research, Figma",
};

const sa = {
   title: "Graphic Artist",
   organization: "Undergraduate Student Association",
   location: "Buffalo, New York",
   web: "https://sa.buffalo.edu/",
   date: "August 2018 - September 2019",
   details: [
      "Completed asset requests given by UBSA or their clubs to create graphic assets for events, " +
         "promotions, et al.",
      "Coordinated with senior leadership to design a set of assets for larger events such as " +
         "the Annual SA Comedy Series, Sexual Violence Prevention Week, Earth Week, et al.",
   ],
   skills: "Graphic Design, Adobe Creative Cloud",
};

const graspie = {
   title: "Design Intern",
   organization: "GRASPIE",
   location: "Buffalo, New York",
   web: "https://www.graspie.com/",
   date: "June 2018 - August 2018",
   details: [
      "Created new UX/UI workflows.",
      "Created deliverables for clients and investors.",
      "Designed 4 mobile " +
         "app pages following Material Design with corresponding style guides.",
      "Designed 23 product mock-ups and " + "sample graphics.",
   ],
   skills: "Graphic Design, UX/UI Design",
};

export const EMPLOYMENT = [ods, sahead, cnbc, sa, graspie];
